import type { StateMachine } from './machine';

/** Service-agreement status machine (core-data-model §2). Only `active` agreements generate
 *  occurrences; a skipped season tombstones on the occurrence, not the agreement. */
export const AGREEMENT_STATES = [
  'draft',
  'active',
  'paused',
  'canceled',
  'expired',
] as const;
export type AgreementState = (typeof AGREEMENT_STATES)[number];

export const agreementMachine: StateMachine<AgreementState> = {
  states: AGREEMENT_STATES,
  initial: 'draft',
  terminal: ['canceled', 'expired'],
  transitions: [
    { from: 'draft', to: 'active', via: 'agreement.activate' },
    { from: 'active', to: 'paused', via: 'agreement.pause' },
    { from: 'paused', to: 'active', via: 'agreement.resume' },
    { from: 'active', to: 'canceled', via: 'agreement.cancel' },
    { from: 'paused', to: 'canceled', via: 'agreement.cancel' },
    { from: 'active', to: 'expired', via: 'agreement.expire', system: true },
  ],
};

export const AGREEMENT_OCCURRENCE_STATES = ['projected', 'generated', 'skipped'] as const;
export type AgreementOccurrenceState = (typeof AGREEMENT_OCCURRENCE_STATES)[number];
